import * as policyEngine from '@/domain/restriction/engine';
import { isFirefox } from '@/lib/systemHelpers/browserHelpers';
import { localRights } from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/helpers/contextMenuHelper';

export const items = [
  {
    id: 'startPaymentProcess',
    title: 'Start payment process',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'sendToApproval',
    title: 'Send to Approval',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'sendByEmail',
    title: 'Share via email',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
  },
  {
    id: 'printDocument',
    title: 'Print document',
    disabled: isFirefox,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
  },
  {
    id: 'downloadDocument',
    title: 'Download document',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
  },
  {
    id: 'saveForLater',
    title: 'Save for later',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'archive',
    title: 'Archive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'unarchive',
    title: 'Unarchive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'deletePayment',
    title: 'Delete payment',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    divided: true,
    isDanger: true,
  },
];

export const filteredItem = (p: { restriction: policyEngine.UserRights }) => {
  const lr = localRights.restriction(p.restriction);

  return items.filter(policyEngine.arrayFilter(lr)).map(policyEngine.arrayMap(lr, 'disabled'));
};
